import React from 'react';
import SharedCalGuide from '../../SharedCalGuide';

const BulkUserStatus = () => {

    return (
        <div className="BulkUserStatus">
            <div className="modal fade" id="userStatusBulkModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="UserStatusBulk" aria-hidden="false">
                <div className="modal-dialog modal-dialog-slideout">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title spacer-inline text-size3" id="myModalLabel">
                                Download
                                <div className="text-size6 line-s1">Big Data</div>
                            </div>
                            <button type="button" className="close" aria-label="Close" data-dismiss="modal">
                                <span aria-hidden="false">&times;</span>
                            </button>
                        </div>
                        <form>
                            <div className="modal-body">
                                <div className="modal-content-body container">
                                    {/* SES Admin only Domain */}
                                    <div className="field-wrapper">
                                        <label for="domain">Domain</label>
                                        <select className="form-control" name="domain">
                                            <option value="">Select</option>
                                        </select>
                                    </div>
                                    {/* SES Admin only Customer */}
                                    <div className="field-wrapper">
                                        <label for="customer">Customer</label>
                                        <select className="form-control" name="customer">
                                            <option value="">Select</option>
                                        </select>
                                    </div>
                                    <div className="descript-container">
                                        Select one or more organizations to search and download user status reports.
                                    </div>
                                    {/* Organization */}
                                    <div className="field-wrapper">
                                        <div className="spacer-inline w-lg8">
                                            <label for="Org">Organization</label> <i className="bi bi-asterisk rd-clr"></i>
                                        </div>
                                        <div className="spacer-inline">
                                            <input className="form-control filter-sm" type="search" placeholder="Filter" />
                                        </div>
                                        {/*- watermark before customer is selected*/}
                                        <div className="watermark-wrapper sp-margin13">Select a customer from above</div>
                                        {/* Org list based on the customer */}
                                        <div className="org-list-container" hidden >
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 1</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 2</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 3</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 4</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization HIE</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 4</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 4</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 4</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 4</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 4</span>
                                            </div>
                                            <div>
                                                <input type="checkbox" className="sp-margin5" /> <span className="v-top">Sample Organization 4</span>
                                            </div>
                                        </div>
                                        <div className="alert alert-danger">Required!</div>
                                    </div>

                                    {/* Calendar */}
                                    <div className="field-wrapper">
                                        {/* Start Date */}
                                        <div className="spacer-margin5 spacer-inline w-md2">
                                            <label for="StartDate">Start Date</label> <i className="bi bi-asterisk rd-clr"></i>
                                            <div className="input-group date" data-provide="datepicker">
                                                <input type="text" className="form-control" name="StartDate" />
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id=""><i className="fas fa-calendar"></i></span>
                                                </div>
                                            </div>
                                            <div className="alert alert-danger">Required!</div>
                                        </div>

                                        {/* End Date */}
                                        <div className="spacer-inline w-md2">
                                            <label for="EndDate">End Date</label> <i className="bi bi-asterisk rd-clr"></i>
                                            <div className="input-group date" data-provide="datepicker">
                                                <input type="text" className="form-control" name="EndDate" />
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id=""><i className="fas fa-calendar"></i></span>
                                                </div>
                                            </div>
                                            <div className="alert alert-danger">Required!</div>
                                        </div>
                                        <div className="text-size1 sp-margin13">
                                            <a href="#collapseCal" data-toggle="collapse" aria-expanded="false" aria-controls="collapseCal">More Info</a>
                                        </div>
                                    </div>
                                    <SharedCalGuide />
                                    {/* Searcy by City */}
                                    <div className="field-wrapper">
                                        <div className="spacer-inline w-md2 spacer-margin5">
                                            <label for="">City</label>
                                            <input className="form-control" />
                                        </div>

                                        {/* Searcy by State */}
                                        <div className="spacer-inline w-md2">
                                            <label for="">State</label>
                                            <select className="form-control">
                                                <option value="">Select</option>
                                            </select>
                                        </div>
                                    </div>

                                    {/* Search by Name */}
                                    <div className="field-wrapper">
                                        <div className="spacer-margin5 spacer-inline w-md2">
                                            <label for="mdn">Name</label>
                                            <select className="form-control w-md2" name="mdn">
                                                <option value="">Search By</option>
                                                <option value="">Username</option>
                                                <option value="">First Name</option>
                                                <option value="">Last Name</option>
                                            </select>
                                        </div>
                                        <input className="form-control spacer-inline w-md2" placeholder="Enter Name" />
                                    </div>
                                    {/* Search by Direct Email */}
                                    <div className="field-wrapper">
                                        <div className="spacer-margin5 spacer-inline w-md2">
                                            <label for="status">Email</label>
                                            <select className="form-control w-md2" name="">
                                                <option value="">Search By</option>
                                                <option value="">Direct Email</option>
                                                <option value="">Contact Email</option>
                                            </select>
                                        </div>
                                        <input className="form-control spacer-inline w-md2" placeholder="Enter Email" />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-success" data-dismiss="modal" data-target="#createFilenameModal" data-toggle="modal">Continue</button>
                                <button type="button" className="btn btn-outline-secondary" data-dismiss="modal">Cancel</button>
                                {/*Processing Spinner*/}
                                <div className="spacer-inline" hidden>
                                    <div className="reverse-spinner spinner1"></div> <div className="spacer-inline spacer-margin2">Processing...</div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

BulkUserStatus.defaultProps = {};

export default BulkUserStatus;
